<template>
  <div class="TopicShare"
       @mouseover="shareHover"
       @mouseleave="isShow = false"
  >
    <i class="iconfont icon-share"/>
    分享
    <!-- 分享内容   -->
    <div class="share-box"
         v-show="isShow"
    >
      <div class="txt-share">分享至</div>
      <div class="icons">
        <div class="icon-item" @click="shareWeibo">
          <div class="iconfont-box weibo">
            <i class="iconfont icon-weibo2"/>
          </div>
          微博
        </div>
        <div class="icon-item" @click="shareXhs">
          <div class="iconfont-box xhs">
            <i class="iconfont icon-xhs2"/>
          </div>
          小红书
        </div>
      </div>
      <div class="share-cg ">
        <div class="share-url overflow-one"> {{ shareUrl }}</div>
        <div class="share-btn text-copy" @click="copy ">复制链接</div>
      </div>
    </div>
  </div>
</template>

<script>
import {fnClipboard, fnRouter} from "../../../fn";
import {PAGE_PATH} from '@/constant/PAGE_PATH'
import {getCollectionStat} from "@/api/topic";

export default {
  name: "TopicShare",
  data() {
    return {
      shareUrl: '潮国创意的【专题名】',
      PAGE_PATH,
      isShow: false
    }
  },
  props: {
    detail: {
      type: Object,
      default: () => {
      }
    }
  },
  mounted() {
    this.shareUrl = `潮国创意网站的内容真不错，强推【${this.detail.title}】合集：` + location.href
  },
  methods: {
    copy() {
      fnClipboard.copy(this.shareUrl)
    },
    shareWeibo(event) {
      event.preventDefault()
      // shareUrl是微博的分享地址，（有资料说需要真实的appkey，必选参数，这里我没用appkey也可以正常分享）
      // count=表示是否显示当前页面被分享数量(1显示)(可选，允许为空)
      // &url=将页面地址转成短域名，并显示在内容文字后面。(可选，允许为空)
      // &appkey=用于发布微博的来源显示，为空则分享的内容来源会显示来自互联网。(可选，允许为空)
      // &title=分享时所示的文字内容，为空则自动抓取分享页面的title值(可选，允许为空)
      // &pic=自定义图片地址，作为微博配图(可选，允许为空)
      // &ralateUid=转发时会@相关的微博账号(可选，允许为空)
      // &language=语言设置(zh_cn|zh_tw)(可选)
      let currentUrl = String(location.href);
      let title = `我在@潮国创意 发现了【${this.detail.title}专题名】这个特色专题，质量不错创意度好，快来围观！链接：`
      var _shareUrl = 'http://service.weibo.com/share/share.php?'
      _shareUrl += 'url=' + encodeURIComponent(currentUrl) //参数url设置分享的内容链接
      _shareUrl += '&title=' + encodeURIComponent(title) //参数title设置分享的标题
      _shareUrl += '&pic=' + PAGE_PATH.BASE_IMG_URL + this.detail.cover_img //参数title设置分享的标题
      // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
      window.open(
        _shareUrl,
        '_blank',
        // 'height=800, width=1000',
        // 'scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes'
      )
    },
    shareXhs() {
      let path = "http://chaopx.com/collection/share-code"
      fnRouter.navigationTo(path)
    },
    async shareHover(){
      this.isShow = true
      await getCollectionStat({position: 'share', id: this.detail.id})
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes fadeinT {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.TopicShare {
  width: 102px;
  height: 44px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(10, 37, 64, 0.1);
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(10, 37, 64, 1);
  font-size: 14px;
  color: #0A2540;
  cursor: pointer;
  position: relative;

  .icon-share {
    margin-right: 8px;
    font-size: 18px;
  }

  &:hover {
    background: linear-gradient(44deg, #FE7E7E 0%, #F94D67 100%);
    color: #FFFFFF;
  }

  .share-box {
    width: 286px;
    height: 164px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 14px;
    @include Position(1, 5, 0, 48px);
    z-index: 9;
    padding: 14px 20px 16px;
    box-sizing: border-box;
    color: #000;
    animation: fadeinT 0.5s 1;

    &:after{
      content: '';
      display: inline-block;
      width: 100%;
      height: 5px;
      //background: pink;
      @include Position(1,5,0,-4px);
    }

    .txt-share {
      font-size: 13px;
      color: #0A2540;
      line-height: 18px;
      margin-bottom: 12px;
    }

    .icons {
      display: flex;
      align-items: center;

      .icon-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 30px;

        font-size: 12px;
        color: #0A2540;
        line-height: 16px;

        .iconfont-box {
          width: 34px;
          height: 34px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 4px;

          &.weibo {
            background: linear-gradient(138deg, #FDCB76 0%, #FFA64E 100%);

            &:hover {
              background: linear-gradient(138deg, #FFA64E 0%, #FDCB76 100%);
            }
          }

          &.xhs {
            background: linear-gradient(135deg, #FC5277 0%, #FA4258 100%);

            &:hover {
              background: linear-gradient(135deg, #FA4258 0%, #FC5277 100%);
            }
          }

          .iconfont {
            color: #FFFFFF;
          }
        }

        .icon-weibo2 {
          font-size: 18px;
        }

        .icon_xhs {

        }
      }
    }

    .share-cg {
      width: 246px;
      height: 36px;
      background: #F5F6FA;
      border-radius: 18px;
      position: relative;
      font-size: 12px;
      color: #0A2540;
      line-height: 36px;
      padding-left: 18px;
      box-sizing: border-box;
      margin-top: 14px;

      .share-url {
        width: 138px;
      }

      .share-btn {
        width: 80px;
        height: 36px;
        background: linear-gradient(137deg, #8686FB 0%, #6969FF 100%);
        border-radius: 18px;
        @include Position(1, 2, 0, 0);
        font-size: 12px;
        color: #FFFFFF;
        line-height: 36px;
        text-align: center;

        &:hover {
          background: linear-gradient(137deg, #6969FF 0%, #8686FB 100%);
        }
      }
    }

  }
}
</style>
